import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_LoginOTPForm = _resolveComponent("LoginOTPForm")!
  const _component_OverviewCardLayout = _resolveComponent("OverviewCardLayout")!
  const _component_LoginLayout = _resolveComponent("LoginLayout")!

  return (_openBlock(), _createBlock(_component_LoginLayout, {
    class: "login-otp__layout",
    title: _ctx.isMobileScreen && _ctx.title,
    subtitle: 
      _ctx.isMobileScreen && _ctx.t('Please enter your OTP (One-Time Password) generated')
    ,
    showLogo: _ctx.isMobileScreen,
    showBackButton: _ctx.isMobileScreen,
    onGoBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('goBack')))
  }, {
    body: _withCtx(() => [
      _createVNode(_component_OverviewCardLayout, { class: "login-otp__card" }, {
        "left-title-element": _withCtx(() => [
          _createVNode(_component_BackButton, {
            showBtnText: false,
            onOnBackClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goBack')))
          })
        ]),
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_LoginOTPForm)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "subtitle", "showLogo", "showBackButton"]))
}